import React, { Component } from 'react'
import UsersList from './UsersList'
import AvailabilityTimeSlots from './AvailabilityTimeSlots'
import CollapseContainer from '../MobileView/CollapseContainer'
import TimeHorizontalScroll from './TimeHorizontalScroll'
import moment from 'moment'
import { formatName } from '../../utils/spaUtils'
var momentRange = require('moment-range');
momentRange.extendMoment(moment);

class ServiceAvailabilityTab extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showUserList: false,
            users: [],
            cruiseDates: []
        }
        this.timeSlots = [
            'Any',
            'Morning',
            'Afternoon',
            'Evening',
            '9:00 AM',
            '10:00 AM',
            '11:00 AM',
            '12:00 PM',
            '1:00 PM',
        ]
        this.showUserList = this.showUserList.bind(this)
        this.onTimeSlotSelect = this.onTimeSlotSelect.bind(this)
        this.onCollapseClose = this.onCollapseClose.bind(this)
        this.onDateSelect = this.onDateSelect.bind(this)
        this.onDateClose = this.onDateClose.bind(this)
        
    }

    onUserClick=(selectedUser)=> {
        this.props.actions.selectGuest(selectedUser)
    }

    getAvailabilityData() {
        let { services } = this.props
        let { itineraryMap } = services
        if (this.state.cruiseDates.length > 0 && this.state.itineraryMap)
            return
        if (services.cruiseStartDate && services.cruiseEndDate) {
            let startDate = moment(services.cruiseStartDate, 'YYYYMMDD'),
                endDate = moment(services.cruiseEndDate, 'YYYYMMDD'),
                range = moment.range(startDate, endDate),
                dateArray = [...range.by('days')]
            var cruiseDates = dateArray.map((date) => {
                let cruiseDate = {}
                cruiseDate.day = date.format('ddd, MMM Do')
                cruiseDate.year = date.get('year')
                cruiseDate.reqDate = date.format('YYYYMMDD')
                let _port = itineraryMap
                    ? itineraryMap.find((port) => port.date === date.format('YYYYMMDD'))
                    : ''
                cruiseDate.location = _port
                    ? _port.portName === 'At Sea'
                        ? _port.portName
                        : _port.portName.split(',')[0]
                    : ''
                cruiseDate.temp = itineraryMap
                return cruiseDate
            })

            let users = services.guestNames
                ? services.guestNames.map((name) => `${name.FirstName} ${name.LastName}`)
                : []
            this.setState({ cruiseDates, users, itineraryMap });
        }
    }
    get MobileView() {
        let { users = [], cruiseDates = [], selectedDate } = this.state
        let { guestDetails, filter } = this.props.services
        let { selectedGuest = '', selectedTimeSlot = '', selectedGuestDetails = {} } = filter

        return (
            <div className="service-availability-container service-availability-container-mobile">
                <div className="availablity-heading  availablity-heading-mobile padding-5 font-size-p2 gotham-xn-medium">
                    <h2 className="align-center ">Select a Guest </h2>
                </div>
                <div className="mobile-collapse-container mob-user-list mobile-user-list">
                    <CollapseContainer
                        onCollapseClose={this.onCollapseClose}
                        triggerText={selectedGuest ? formatName(selectedGuest) : 'All '}
                        isOpen={this.state.showUserList}
                        onCollapseTriggerClick={this.showUserList}>
                        <UsersList
                            selectedGuest={selectedGuest}
                            selectedGuestDetails={selectedGuestDetails}
                            guestDetails={guestDetails}
                            onUserClick={this.onUserClick}
                            users={users}
                            isMobile={true}
                            showAll={true}
                        />
                    </CollapseContainer>
                </div>
                <div className="availablity-heading  availablity-heading-mobile padding-5">
                    <h2 className="align-center spa-bold font-size-p2 gotham-xn-medium">Choose a Date & Time </h2>
                </div>
                <div className="mobile-collapse-container mobile-dates-list font-size-p2 gotham-xn-medium">
                    {cruiseDates.map((date, i) => (
                        <CollapseContainer
                            key={date.day}
                            onCollapseClose={this.onDateClose}
                            triggerText={`${date.day}.  ${date.location}`}
                            isOpen={date.day.trim() === selectedDate}
                            onCollapseTriggerClick={this.onDateSelect.bind(
                                this,
                                date.day,
                                date.year,
                                true,
                                date.reqDate
                            )}>
                            <TimeHorizontalScroll
                                selectedTimeSlot={selectedTimeSlot}
                                onTimeSlotSelect={this.onTimeSlotSelect}
                                displayNavButtons={false}
                                timeSlots={this.timeSlots}>
                            </TimeHorizontalScroll>
                        </CollapseContainer>
                    ))}
                </div>
            </div>
        )
    }

    showUserList() {
        this.setState({ showUserList: true })
    }

    onCollapseClose() {
        this.setState({ showUserList: false })
    }

    onDateSelect(selectedDate, year, formatted, reqdate) {
        let _selectedDate = selectedDate
        if (!formatted) {
            _selectedDate = selectedDate ? selectedDate.split('.')[0].trim() : ''
        }
        this.setState({ selectedDate: _selectedDate })
        this.props.actions.setSelectedDate(_selectedDate, year, reqdate)
    }

    onTimeSlotSelect(event) {
        let selectedTimeSlot = event.target.textContent
        this.props.actions.selectTimeSlot(selectedTimeSlot)
    }

    onDateClose() {
        this.setState({ selectedDate: '' })
    }

    componentWillReceiveProps() {
        this.getAvailabilityData()
    }

    componentDidMount() {
        this.getAvailabilityData()
    }

    render() {
        let { users } = this.state
        let { filter = {}, itineraryMap, guestDetails = [] } = this.props.services
        let {
            selectedDate,
            selectedGuest = '',
            selectedTimeSlot = '',
            selectedCategory = '',
            selectedGuestDetails
        } = filter

        if (this.props.isMobileView) return <>{this.MobileView}</>

        return (
            <article className="service-availability-container padding-10">
                <section>
                    <div className="availablity-heading">
                        <h2
                            className="align-center font-size-p18"
                            data-test-id="select-guest">
                            Select a Guest
                        </h2>
                    </div>
                    <div className="availability-users-list">
                        <UsersList
                            guestDetails={guestDetails}
                            selectedGuest={selectedGuest}
                            selectedGuestDetails={selectedGuestDetails}
                            onUserClick={this.onUserClick}
                            users={users}
                            showAll={true}
                        />
                    </div>
                </section>
                <section>
                    <div className="availablity-heading">
                        {selectedCategory === 'Relaxation Areas'
                            ?
                            <h2
                                className="align-center font-size-p18 pad-top15px"
                                data-test-id="data-time-text">
                                Choose a Date
                            </h2>
                            :
                            <h2
                                className="align-center font-size-p18 pad-top15px"
                                data-test-id="data-time-text">
                                Choose a Date & Time
                            </h2>
                        }
                    </div>
                    {/* <h4 className='align-center font-size-m3' data-test-id="time-approximate-text">Times are approximate.</h4> */}
                    <div className="availablity-date-time margin-top-min20px">
                        <AvailabilityTimeSlots
                            selectedCategory={selectedCategory}
                            itineraryMap={itineraryMap}
                            selectedTimeSlot={selectedTimeSlot}
                            onTimeSlotSelect={this.onTimeSlotSelect}
                            selectedDate={selectedDate}
                            onDateSelect={this.onDateSelect}
                            timeSlots={this.timeSlots}
                            cruiseDates={this.state.cruiseDates}
                        />
                    </div>
                </section>
            </article>
        )
    }
}

export default ServiceAvailabilityTab